import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Card, Icon, Button, Input, Label, Reveal, Image, Dropdown } from "semantic-ui-react"
import ImageWithFallback from "components/ImageWithFallback"
import './ProductCard.scss';
import shop from "shop/shop"
import Price from "components/Price/Price"
import ButtonLove from "components/Button/ButtonLove"
import Responsive from "react-responsive" 

class ProductCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isHovered: false,
      count: 0
    };
  }

  render() {
    const { isHovered } = this.state
    let { product, categoryId = "", currentOffset = 0 } = this.props
    const inCart = shop.cart.productsById.get(product.map_id) || product
    const useQuickorder = shop.config.plugin.orderFromTile && shop.session
    let cardHeight = shop.session ? "350px" : "250px"
    //console.log("currentOffset location", currentOffset)
    if (!product) return <div>LOADING</div>

    return (
      <Card className="product ProductCard items-center" style={{ minHeight: cardHeight, padding: "5px" }}>
        {shop.session && <div className="absolute top-1 right-1 z-999 ">
          <ButtonLove list={shop.orderlist.default}
            className="dib mr3"
            elementInActive={<span><Icon name={"heart outline"} /></span>}
            elementActive={<span><Icon name={"heart"} /></span>}
            product={product} />
        </div>}
        <div className="badges absolute left-1 top-1 black-50 z-999 ">
          {product.extras && product.extras.neuheit && product.extras.neuheit.value && product.extras.neuheit.value.value && <span className="labelNeu1">&nbsp;&nbsp;{translate("Neu")}&nbsp;&nbsp;</span>}
          {product.pinfos && product.pinfos.rabatt && product.pinfos.rabatt < 0 && <span className="labelRabatt">&nbsp;&nbsp;{product.pinfos.rabatt + '%'}&nbsp;&nbsp;</span>}
        </div>
        <Link className="product-inner" to={`/product/${product.map_id}/?category=${categoryId}&offset=${currentOffset}`}>
          <div style={{minHeight: "200px", minWidth: "200px"}}
            className="product-image-container relative flex justify-center "
            onMouseEnter={() => window.matchMedia && window.matchMedia("(hover: hover)").matches && this.setState({ isHovered: true })}
            onMouseLeave={() => this.setState({ isHovered: false })}
          >
            {/**/}
            <ImageWithFallback
              src={product.img_src_medium}
              fallback="/image/placeholder.png"
              style={{
                maxWidth: "200px",
                maxHeight: "200px",
                minWidth: "200px",
                minHeight: "200px",
                objectFit: "contain",
                position: "absolute",
                transition: "opacity 0.5s",
                opacity: isHovered ? 0 : 1,
              }}
              className="product-image"
            />

            <ImageWithFallback
              src={product.img_src_hover}
              fallback="/image/placeholder.png"
              style={{
                maxWidth: "200px",
                maxHeight: "200px",
                minWidth: "200px",
                minHeight: "200px",
                objectFit: "contain",
                position: "absolute",
                transition: "opacity 0.8s",
                opacity: isHovered ? 1 : 0,
              }}
              className="product-image"
            />

          </div>
          <div className="tc ">
            <Card.Content className="v-btm" style={{ verticalAlign: "bottom", horizontalAlign: "center" }}>
              <Card.Header className="tc product-title" title={product.title}>
                {product.title.toUpperCase()}
              </Card.Header>
              <Card.Meta className="tc product-meta">
                <div className="flex flex-row justify-center"><div className="product-article">{translate("Art. Nr.")} {product.article_nr.toUpperCase()}</div> {shop.session && product.getNotice("tiny")}</div>
              </Card.Meta>
            </Card.Content>
          </div>
        </Link>
        {shop.session && <ProductQuantitySimple product={product} inCart={inCart} />}
      </Card>
    );
  }

  handleQuickOrder = (product) => {
    // Implement quick order functionality
  };
}

function ProductQuantitySimple({ product, inCart = {} }) {
  const [count, setCount] = React.useState(inCart && inCart.count || 1)
  const [isDirty, setDirty] = React.useState(false)
  const [isLoading, setLoading] = React.useState(false)
  const same = count === inCart.count
  React.useEffect(() => {
    if (isDirty) return // so the input doesnt overwrite user inputted data
    if (inCart.count > 0) setCount(inCart.count)
    else setCount(1)
  }, [product, inCart])
  return <div className="flex flex-row justify-center items-center bottom-0 absolute">
    <div className="pr3 price-container">
      {shop.session && <div>
        {product.isSale && shop.session.shopuser && !shop.session.shopuser.guest &&
          <div className="price color" title={translate("Stückpreis")}>
            <span className="f5 red b"><Price>{product.price}</Price></span>
          </div>}
        {!product.isSale && shop.session.shopuser && !shop.session.shopuser.guest &&
          <div className="price color">
            <span className="f5  b"><Price>{product.price}</Price></span>
          </div>}
        {/*inCart.count == 0 && <div className={"f6 black-80"}>1 {translate("VE")} {product.unit_multi} {translate("Stk")}</div>*/}
        {count && <div className={"f6 black-80"}>{count} {translate("VE")} {count * inCart.unit_multi} {translate("Stk")}</div>}
      </div>
      }
    </div>
    <div className={"flex flex-row"}>
      <div className={"ProductQuantitySimple flex flex-row items-center"}>
        <div className={"pr2"} style={{ width: "80px" }}><Input onChange={e => {
          setCount(e.currentTarget.value)
          setDirty(true)
        }} value={count} fluid type={"number"} min={0} /></div>
        <Button
          primary
          loading={isLoading}
          icon={same ? "shopping cart" : "plus"}
          onClick={async () => {
            let n = count

            if (!n) {
              n = 1
            } else {
              if (same) return
            }

            setLoading(true)
            product.count = n
            shop.cart.add(product)
            setDirty(false)
            await delay(300)
            shop.toast(`${product.count} ${product.unit_desc} x ${product.title} ${translate("im Warenkorb")}`, "info", false, "bottom")
            setLoading(false)
          }} />
      </div>
    </div>
  </div>
}

function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export default ProductCard;


// WEBPACK FOOTER //
// ./src/theme/mags/components/Product/ProductCard.js